module.exports = __webpack_public_path__ + "img/min-integration.a8fcb563.svg";